import React from 'react';
import { connect } from 'react-redux';
import '../../styles/styles.scss';
import PropTypes from 'prop-types';
import jwt_decode from 'jwt-decode';
import { getTimeToExpire } from '../../utils/token';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import SessionTimeout from '../Modal/SessionTimeout.js';
import PowerOff from '../../assets/img/power-off.png';

export class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.interval = setInterval(
      () => this.setState({ time: getTimeToExpire() }),
      1000
    );
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const token = localStorage.getItem('QUSER');
    const language = localStorage.getItem('LANGUAGE');
    let userDisplayName = (
      <FormattedMessage
        id="app.header.unauthorized"
        defaultMessage="UNAUTHORIZED"
      />
    );
    let userEmail = '';

    try {
      const decoded = jwt_decode(token);
      let expire = decoded.exp;
      expire = moment.unix(expire);
      if (expire.isAfter()) {
        userDisplayName = decoded.displayName;
        userEmail = decoded.email;
      }
    } catch (err) {
      console.error('invalid token');
    }

    const languages = ['en', 'cs'];

    return (
      <nav className="navbar navbar-expand-lg fixed-top navbar-dark bg-skoda-green">
        <a className="navbar-brand mr-auto mr-lg-0" href="/">
          Car feedback admin
        </a>
        <div className="collapse navbar-collapse" id="navbarText">
          <div className="navbar-nav mr-auto"></div>
          <div className="navbar-text text-right small">
            <b>{userDisplayName}</b>
            <br />
            {userEmail}
          </div>
          <div className="navbar-text text-right small">
            <div style={{ padding: '0px 25px', textAlign: 'center' }}>
              <b>{this.state.time}</b>
              <br />
              <FormattedMessage id={'app.header.logout'}>
                {(message) => (
                  <img
                    className="mt-1"
                    src={PowerOff}
                    width="20"
                    onClick={() => this.logout()}
                    alt={message}
                    style={{ cursor: 'pointer' }}
                  />
                )}
              </FormattedMessage>
              {this.state.time === '0:00' && <SessionTimeout />}
            </div>
          </div>
          <div
            className="navbar-text text-right small"
            style={{ marginLeft: '15px' }}
          >
            <select
              className="language"
              onChange={(event) => this.changeLanguage(event)}
              value={language}
            >
              {languages.map((language, i) => (
                <FormattedMessage
                  id={'app.header.language.' + language}
                  defaultMessage="unknown"
                  key={i}
                >
                  {(message) => <option value={language}>{message}</option>}
                </FormattedMessage>
              ))}
            </select>
          </div>
        </div>
      </nav>
    );
  }

  changeLanguage = (event) => {
    localStorage.setItem('LANGUAGE', event.target.value);
    window.location.href = window.location.href;
  };

  logout = () => {
    clearInterval(this.interval);
    localStorage.setItem('QUSER', '');
    this.setState({ time: getTimeToExpire() });
  };
}

function mapStateToProps(state) {
  return {};
}

Header.propTypes = {
  timeout: PropTypes.bool,
};

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
